export const SET_CLIENTS = 'SET_CLIENTS';
export const SET_IS_LOADING_GET_CLIENTS = 'SET_IS_LOADING_GET_CLIENTS';
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const IS_LOADING_SELECT_CLIENT = 'IS_LOADING_SELECT_CLIENT';
export const SEARCH_CLIENTS = 'SEARCH_CLIENTS';
export const SEARCH_POINTS_OF_SALE = 'SEARCH_POINTS_OF_SALE';
export const SET_POINTS_OF_SALE = 'SET_POINTS_OF_SALE';
export const CREATE_CLIENT = 'CREATE_CLIENT';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const SET_IS_LOADING_UPDATE_CLIENT = 'SET_IS_LOADING_UPDATE_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const SELECT_POINT_OF_SALE = 'SELECT_POINT_OF_SALE';
export const CREATE_POINT_OF_SALE = 'CREATE_POINT_OF_SALE';
export const UPDATE_POINT_OF_SALE = 'UPDATE_POINT_OF_SALE';
export const REMOVE_POINT_OF_SALE = 'REMOVE_POINT_OF_SALE';
export const REFRESH_CLIENTS = 'REFRESH_CLIENTS';
export const SET_SEGMENTATIONS = 'SET_SEGMENTATIONS';
export const UPDATE_EXCHANGE_RATE = 'UPDATE_EXCHANGE_RATE';
export const ADD_NEW_EXCHANGE_RATE = 'ADD_NEW_EXCHANGE_RATE';
